import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import AppRoutes from "./routes/AppRoutes";
import ErrorBoundary from "./components/error-boundary/ErrorBoudary";
import { useConf } from "./context/ConfContext";

function App() {
  const navigate = useNavigate();
  const [oktaAuth, setOktaAuth] = useState({} as OktaAuth);
  const { conf, error, loading } = useConf();

  useEffect(() => {
    if (!loading && !error && conf) {
      const issuer = conf.REACT_APP_OKTA_ISSUER_URL as string;
      const clientId = conf.REACT_APP_OKTA_CLIENT_ID as string;
      
      setOktaAuth(
        new OktaAuth({
          issuer,
          clientId,
          redirectUri: window.location.origin + "/login/callback",
          scopes: ["default", "openid", "profile", "email"],
          pkce: true,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conf]);

  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "", window.location.origin));
  };

  return (
    <ErrorBoundary>
      {Object.keys(oktaAuth).length > 0 && (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <AppRoutes />
        </Security>
      )}
    </ErrorBoundary>
  );
}

export default App;
